import '~/js/modules/stickyNav';
import RoomAccommodations from '~/js/components/accommodations/MainPanel';
import dataLayerProvider from '~/js/modules/resorts/datalayer-provider';

const { dataLayer = {} } = window.beaches_app.page;

dataLayerProvider.inject(dataLayer);

// these are italian
// const caribbeanVillageRooms = ['TWP', 'PP', 'G2', 'M2P', 'FWP', 'MP', 'NP', 'RW', 'S2', 'D2', 'R2', 'PW', 'T2', 'V2'];
// these "are" caribbean
// const caribbeanVillageRooms = ['P2', 'IS', 'HG1', 'G1', 'LV1', 'HJ', 'GD', 'GK', 'HPK', 'HPD', 'PD', 'PK', 'DD', 'DK'];
const villageCode = 'BCV';

const isMobileDevice = () => {
  return (
    typeof window.orientation !== 'undefined' ||
    navigator.userAgent.indexOf('IEMobile') !== -1
  );
};

if (isMobileDevice()) {
  const element = document.querySelector('.drag-icon');

  element.classList.add('mobile-browser');
}

ReactDOM.render(
  <RoomAccommodations
    resortCode="btc"
    villageCode={ villageCode }
    accomodationTitle="the caribbean & seaside villages"
  />,
  document.querySelector('#root')
);
